import { h } from "preact";
import { useCallback, useState } from "preact/hooks";
import { ToolIcon } from "./toolicon";
import "./passwordfield.scss";

// todo: callback

// todo: similar to the epic store, it should have an optional info icon, with a tooltip about password requirements and best practice

interface Props {
    id: string;
    name?: string;
    value?: string;
    placeholder?: string;
    className?: string;
    size?: "default" | "small" | "medium" | "large";
    state?: "valid" | "invalid";
    disabled?: boolean;
    autoComplete?: string;
    callback?: h.JSX.GenericEventHandler<HTMLInputElement>;
}

export function PasswordField(props: Props) {
    const [isVisible, setIsvisible] = useState(false);
    const css_size = (!props.size || props.size === "default") ? " medium" : (" " + props.size);
    return (
        <div class="component-password-container">
            <input
                id={props.id}
                name={props.name}
                type={isVisible ? "text" : "password"}
                value={props.value}
                placeholder={props.placeholder}
                class={(props.state ?? "") + css_size}
                disabled={props.disabled}
                onChange={props.callback}
                autoComplete={props.autoComplete}
                onKeyUp={props.callback} />
            <ToolIcon icon={isVisible ? "visibility" : "visibility-off"} disabled={props.disabled} onClick={() => setIsvisible(!isVisible)} />
        </div>
    );
}
